import React from 'react';
import useSWR from 'swr';
import './earnings-list.css'; // Specific CSS for earnings list
import EarningItem from './EarningItem';
import { API_URL } from 'configuration/urls';

// Helper function to get earnings URL
const getEarningsUrl = (storeId, restaurantId, level = 0) => {
  if (!storeId || !restaurantId) return null;
  return `${API_URL}loyalty/v1/user/earning?storeId=${storeId}&restaurantId=${restaurantId}&level=${level}`;
};

// SWR fetcher function for earnings
const fetchEarningsSWR = async (url) => {
  if (!url) return null;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch earnings: ${response.status}`);
    }
    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    throw error;
  }
};

// Main EarningsList Component
const EarningsList = ({
  storeId,
  restaurantId,
  level,
  themeColors,
  pointsTerminology = 'points',
}) => {
  const earningsKey = getEarningsUrl(storeId, restaurantId, level);

  const {
    data: earnings,
    error,
    isLoading,
  } = useSWR(earningsKey, fetchEarningsSWR, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    dedupingInterval: 10000, // dedupe requests within 10 seconds
  });

  if (isLoading) {
    return (
      <div className='earnings-list-loading'>
        {[1, 2, 3].map((item) => (
          <div key={item} className='earning-placeholder'></div>
        ))}
      </div>
    );
  }

  if (error) {
    return <div className='earnings-error'>Failed to load earnings</div>;
  }

  if (!earnings || earnings.length === 0) {
    return (
      <div className='no-earnings'>
        No earning opportunities available at the moment
      </div>
    );
  }

  return (
    <div className='earnings-list-container'>
      {earnings.map((earning, index) => (
        <React.Fragment key={earning.id || index}>
          <EarningItem
            earning={earning}
            themeColors={themeColors}
            pointsTerminology={pointsTerminology}
          />
          {index < earnings.length - 1 && (
            <div className='earnings-divider'></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default EarningsList;
